import { fetchRequest } from "@/plugins/fetchRequest";

const actions = {
  list({ commit }: StoreProp, { status, name }: UnknownObj) {
    const params: string[] = [];
    if (status) {
      params.push(`status=${status}`);
    }

    if (name) {
      params.push(`client.qname=${name}`);
    }

    return new Promise((resolve, reject) => {
      fetchRequest({ url: `partners?${params.join("&")}` })
        .then((responseData = {}) => {
          const partners: Partner[] = responseData?.data || responseData;
          if (commit) {
            commit("PARTNERS_UPDATE", partners);
            resolve(partners);
          }
        })
        .catch((err: UnknownObj) => {
          reject(err);
        });
    });
  },
  add({ commit }: StoreProp, partner: Partner) {
    return new Promise((resolve, reject) => {
      fetchRequest({
        method: "post",
        url: "partners",
        body: partner as BodyInit
      })
        .then((responseData = {}) => {
          const partner: Partner = responseData?.data || responseData;
          if (commit) {
            resolve(partner);
          }
        })
        .catch((err: UnknownObj) => {
          reject(err);
        });
    });
  },
  remove({ commit }: StoreProp, partnerId: string) {
    return new Promise((resolve, reject) => {
      fetchRequest({
        method: "delete",
        url: `partners/${partnerId}`
      })
        .then((responseData = {}) => {
          const response: UnknownObj = responseData?.data || responseData;
          if (commit) {
            resolve(response);
          }
        })
        .catch((err: UnknownObj) => {
          reject(err);
        });
    });
  }
};

export default actions;
